module.exports = __webpack_public_path__ + "img/horizontal_4_5_8003.a7ff3474.png";